import React from 'react';
import logo from '../../../Assets/logo.png';
import zepcruitDoneIcon from '../../../Assets/svgs/zepcruitDoneIcon.svg';
import { ButtonWithIcon, ButtonWithoutIcon } from '../../../constents/components';
import { useNavigate } from 'react-router-dom';
import useRouteFunctions from '../../../Hooks/Routes/useRouteFunctions';
import useRedirect from '../../../Hooks/Auth/useRedirect';

const PopUp = () => {
    const { goToDashboard } = useRouteFunctions();
    const { redirect } = useRedirect();

    return (
        <div className=' fixed top-0 right-0 left-0 bottom-0 flex items-center justify-center p-8 bg-popup-bg-color backdrop-blur-[2px] z-[--after-registration-popup]'>
            <div className=' bg-white w-full md:w-4/5 lg:w-2/5 rounded-2xl flex flex-col items-center p-6 pt-12'>
                <img
                    className=' h-8'
                    src={logo}
                    alt="zepcruit-icon"
                />
                <img
                    className=' h-16 mt-24'
                    src={zepcruitDoneIcon}
                    alt="zepcruitDoneIcon"
                />
                <h1 className=' font-semibold'>Your are almost done!</h1>

                <ButtonWithoutIcon
                    onButtonClick={() => redirect()}
                    text={'Continue'}
                    classNames=' w-full p-2 mt-4'
                />
            </div>
        </div>
    )
}

export default PopUp;